module.exports = __webpack_public_path__ + "static/media/angel-left.42e340a6.svg";